export const menuOptions = [{ id: 'payment_terms', name_lang: 'account/billing_info.string53' }];
